type ConfiguratorStepSearch = {
  /** The step the reader stands on, as a step key. */
  step?: string
}

/**
 * Both routes that render the configurator validate their search through this,
 * so a step key survives a reload on either of them — and the write side can
 * assume the parameter is kept rather than dropped by the route.
 *
 * A number is read as well as a string: a step key naming no room and no floor
 * is the question id on its own, and the router's default `parseSearch` runs
 * `JSON.parse` over every value, so `?step=41` arrives as the number 41.
 */
export const validateConfiguratorSearch = (
  search: Record<string, unknown>,
): ConfiguratorStepSearch => ({
  step:
    typeof search.step === 'string' || typeof search.step === 'number'
      ? String(search.step)
      : undefined,
})
